<template>
    <div
        class="object-menu"
        role="menu"
        :style="{ top: _clamp(menu_position.y, 0, clamp.y) + 'px', left: _clamp(menu_position.x, 0, clamp.x) + 'px' }"
        ref="object_context_menu"
    >
        <header class="object-menu__header">
            <div class="object-menu__icon"></div>
            <div class="object-menu__title-block">
                <span class="object-menu__title">{{ object_type || 'Canvas Object' }}</span>
                <span class="object-menu__meta">Layer actions</span>
            </div>
        </header>

        <div class="object-menu__section">
            <p class="object-menu__section-title">Quick Actions</p>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">D</span>
                <span class="object-menu__label">
                    <strong>Duplicate</strong>
                    <!-- <small>Clone this object on the canvas</small> -->
                </span>
                <span class="object-menu__shortcut">Ctrl + D</span>
            </button>
            <button type="button" class="object-menu__item" role="menuitem" ref="menubtn-export">
                <span class="object-menu__badge">EX</span>
                <span class="object-menu__label">
                    <strong>Export</strong>
                    <!-- <small>Save out this layer</small> -->
                </span>
                <span class="object-menu__shortcut">Ctrl + Shift + E</span>
            </button>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">R</span>
                <span class="object-menu__label">
                    <strong>Rename</strong>
                    <!-- <small>Edit the layer title</small> -->
                </span>
                <span class="object-menu__shortcut">Enter</span>
            </button>
            <button type="button" class="object-menu__item is-destructive" role="menuitem" ref="menubtn-delete">
                <span class="object-menu__badge">DEL</span>
                <span class="object-menu__label">
                    <strong>Delete</strong>
                    <!-- <small>Remove this object permanently</small> -->
                </span>
                <span class="object-menu__shortcut">Delete</span>
            </button>
        </div>
        <div class="object-menu__divider"></div>

        <div class="object-menu__section">
            <p class="object-menu__section-title">Arrange</p>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">F</span>
                <span class="object-menu__label">
                    <strong>Bring to Front</strong>
                    <!-- <small>Place above every other layer</small> -->
                </span>
                <span class="object-menu__shortcut">Shift + ]</span>
            </button>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">B</span>
                <span class="object-menu__label">
                    <strong>Send to Back</strong>
                    <!-- <small>Move behind every layer</small> -->
                </span>
                <span class="object-menu__shortcut">Shift + [</span>
            </button>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">N</span>
                <span class="object-menu__label">
                    <strong>Nudge Layer</strong>
                    <!-- <small>Shift forward one position</small> -->
                </span>
                <span class="object-menu__shortcut">Ctrl + ]</span>
            </button>
        </div>

        <div class="object-menu__divider"></div>

        <div class="object-menu__section">
            <p class="object-menu__section-title">Align</p>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">L</span>
                <span class="object-menu__label">
                    <strong>Align Left</strong>
                    <!-- <small>Snap object to the left edge</small> -->
                </span>
                <span class="object-menu__shortcut">Ctrl + Alt + L</span>
            </button>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">C</span>
                <span class="object-menu__label">
                    <strong>Align Center</strong>
                    <!-- <small>Center horizontally on canvas</small> -->
                </span>
                <span class="object-menu__shortcut">Ctrl + Alt + C</span>
            </button>
            <button type="button" class="object-menu__item" role="menuitem">
                <span class="object-menu__badge">M</span>
                <span class="object-menu__label">
                    <strong>Align Middle</strong>
                    <!-- <small>Center vertically on canvas</small> -->
                </span>
                <span class="object-menu__shortcut">Ctrl + Alt + M</span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "ObjectContextMenuComp",
    data() {
        return {
            clamp: {
                x: 0,
                y: 0
            }
        }
    },
    props: {
        object_uid: {
            type: String,
            required: false
        },
        creator: {
            type: Object,
            required: false
        },
        object_type: {
            type: String,
            required: false // false for now
        },
        menu_position: {
            type: Object,
            required: false,
            default: {
                x: 0,
                y: 0
            }
        }
    },
    mounted() {
        const {x, y, width, height} = this.$refs.object_context_menu.getBoundingClientRect();

        this.clamp.x = window.innerWidth - width;
        this.clamp.y = window.innerHeight - height;

        this.$refs['menubtn-delete'].addEventListener('click', (event) => {
            this.creator.deleteObject({ uid: this.object_uid });

            this._hide_context_menu();
        });
        this.$refs['menubtn-export'].addEventListener('click', (event) => {
            this.creator.exportObject({ uid: this.object_uid });

            this._hide_context_menu();
        });
    },
    methods: {
        _clamp(x, min, max) {
            return Math.min(Math.max(x, min), max);
        },
        _hide_context_menu() {
            this.creator.context.canvas.dispatchEvent(new CustomEvent('creator:object:contextmenu', {
                detail: {
                    open: false,
                    object: null,
                    position: {
                        x: 0,
                        y: 0
                    }
                }
            }));
        }
    }
}
</script>
<style scoped>
.object-menu {
    position: absolute;
    min-width: 240px;
    max-width: 288px;
    padding: 12px;
    border-radius: 12px;
    background: var(--panel);
    border: 1px solid var(--border);
    box-shadow: 0 20px 40px rgba(8, 12, 20, 0.5);
    display: grid;
    gap: 10px;
    color: var(--text);
    z-index: 100;
}

.object-menu__header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.object-menu__icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--accent);
    box-shadow: 0 0 0 6px rgba(78, 161, 255, 0.18);
}

.object-menu__title-block {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.object-menu__title {
    font-size: small;
    font-weight: 600;
    letter-spacing: 0.01em;
}

.object-menu__meta {
    font-size: xx-small;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--muted);
}

.object-menu__section {
    display: grid;
    gap: 6px;
}

.object-menu__section-title {
    font-size: x-small;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--muted);
    margin: 0 8px;
}

.object-menu__item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 0px 12px;
    font-size: x-small;
    border-radius: 10px;
    border: none;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: pointer;
    transition: background 0.15s ease, transform 0.15s ease;
}

.object-menu__item:hover,
.object-menu__item:focus-visible {
    background: var(--panel-2);
    transform: translateY(-1px);
    outline: none;
}

.object-menu__item.is-destructive {
    color: #ff8080;
}

.object-menu__badge {
    min-width: 32px;
    height: 26px;
    border-radius: 8px;
    background: var(--panel-2);
    color: var(--muted);
    font-size: 11px;
    font-weight: 600;
    display: grid;
    place-items: center;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.object-menu__label {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
}

.object-menu__label strong {
    font-size: small;
    font-weight: 600;
}

.object-menu__label small {
    font-size: 11px;
    color: var(--muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.object-menu__shortcut {
    font-size: 11px;
    font-family: "JetBrains Mono", "SFMono-Regular", ui-monospace, Menlo, Consolas, monospace;
    color: var(--muted);
}

.object-menu__divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.08);
}
</style>

